import React from 'react';
import {Image} from 'react-bootstrap';

import './MediaBar.css';

class MediaBar extends React.Component {

    propTypes: {
        onChange:   React.PropTypes.func,
        Pause:      React.PropTypes.func,
        Play:       React.PropTypes.func,
        hideBar:    React.PropTypes.func,
        showBar:    React.PropTypes.func
    }

    constructor(props) {
        super(props);
        this.mediaBarWidth = React.createRef()

        this.state = {
            value: 0,
            seconds: 0,
            duration: 0,
            isPlaying: false,
            downButtonActive: true
        };
    }

    isPlaying() {
        return (this.state.isPlaying);
    }

    setValue(value, seconds, duration) {
        //console.log("Setting value: " + value);
        this.setState({
            value: value,
            seconds: seconds,
            duration: duration
        });
    }

    setPaused() {
        //console.log("Media Bar .setPaused");
        this.setState({
            isPlaying: false
        });
    }

    //display-state only: Map drives the videos and tells the bar what to show. (This used
    //to fire onChange too, which re-seeked all four videos to the bar's last position on
    //every resume -- the sync engine makes that both unnecessary and undesirable.)
    setPlaying() {
        this.setState({
            isPlaying: true
        });
    }

    //the play/pause icon is a real button: resume/pause at the current position, distinct
    //from clicking the bar to seek. stopPropagation keeps the bar's seek handler out of it.
    handlePlayClick = (e) => {
        e.stopPropagation();

        if (this.state.isPlaying)
        {
            if (typeof this.props.Pause === 'function') {
                this.props.Pause();
            }
        }
        else
        {
            if (typeof this.props.Play === 'function') {
                this.props.Play();
            }
        }
    }

    renderPlayButton()
    {
        return (
            <span className="playButton" onClick={this.handlePlayClick}>
                <Image src={this.state.isPlaying ? "pause.png" : "play.png"} width="24" />
            </span>
        )
    }

    renderDownButton()
    {
        if (this.state.downButtonActive)
            return (
                <Image src="down.png" width="24" />
            )
        else
            return (
                <Image src="up.png" width="24" />
            )
    }

    renderTimeInfo() {

        if (isNaN(parseFloat(this.state.seconds)) || isNaN(parseFloat(this.state.duration)))
        {
            return ("Loading...");
        }
        else
        {
            return (parseFloat(this.state.seconds).toFixed(1) + " of " + parseFloat(this.state.duration).toFixed(1) + "[s] at " + parseFloat(this.state.value).toFixed(1) + '%');
        }
    }

    render() {
        const style = {
            width: this.state.value + '%'
        };

        return (
            <div ref={this.mediaBarWidth} className="mediaBar" onClick={(e) => { this.handleClick(e); }} >
            <div className="bar" style={style} />
            <div className="hider">{ this.renderDownButton() }</div>
            <div className="mediaInfo">{ this.renderPlayButton() } {this.renderTimeInfo()}</div>
            </div>
        );
    }

    handleClick(e) {

        if (this.state.isPlaying)
        {
            //display state follows via setPaused() from the owner
            if (typeof this.props.Pause === 'function') {
                this.props.Pause();
            }
        }
        else
        {
            if (e.clientX <= 24)
            {
                if (this.state.downButtonActive)
                {
                    this.setState({
                        downButtonActive: false
                    });

                    if (typeof this.props.hideBar === 'function') {
                        this.props.hideBar();
                    }
                }
                else
                {
                    this.setState({
                        downButtonActive: true
                    });

                    if (typeof this.props.showBar === 'function') {
                        this.props.showBar();
                    }
                }
                //console.log("the down button has been pressed!");
            }
            else
            {
                //a seek: report the new position; whether playback resumes (and so what the
                //play icon shows) is the owner's decision -- with the zoom popup open a seek
                //scrubs the paused group instead of resuming it
                const relativeWidth = 100 * e.clientX / this.mediaBarWidth.current.offsetWidth;
                this.setState({
                    value: relativeWidth
                });

                if (typeof this.props.onChange === 'function') {
                    this.props.onChange(relativeWidth);
                }
            }
        }
    }
}
export default MediaBar;
